import request from '@/utils/request'

// export const getdatalist = (params: any) =>
//   request({
//     url: '/api/getexpertlist',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getdatalist = (params: any) =>
  request({
    url: '/reviewer/QueryReviewer',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const insertexpert = (params: any) =>
//   request({
//     url: '/api/insertexpert',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const insertexpert = (params: any) =>
  request({
    url: '/reviewer/addReviewer',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getexpertinfo = (params: any) =>
//   request({
//     url: '/api/getexpertinfo',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const getexpertinfo = (params: any) =>
  request({
    url: '/reviewer/getReviewerById',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const updateexpert = (params: any) =>
//   request({
//     url: '/api/updateexpert',
//     method: 'post',
//     data: params,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const updateexpert = (params: any) =>
  request({
    url: '/reviewer/updateReviewer',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })